import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { ButtonInputModel } from 'src/app/presentation/general/button/button.component';
import { Subscription } from 'rxjs';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import { Calorie } from 'src/app/core/model/generate-response-model';
import { DifficultyService } from 'src/app/data/repository/generate-repository/difficulty.service';

@Component({
  selector: 'app-difficulty',
  templateUrl: './difficulty.component.html',
  styleUrls: ['./difficulty.component.scss'],
})
export class DifficultyComponent implements OnInit, OnDestroy {
  @Input() isDetail = false;
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;

  configButtons: ButtonInputModel[] = new Array();
  dataIsReady = false;

  subscription: Subscription;

  constructor(
    private submitButtonShared: SubmitButtonShared,
    private generateShared: GenerateShared,
    private generateService: GenerateService,
    private difficultyService: DifficultyService
  ) {
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (this.isDetail) {
          if (clicked && this.pageNumber === this.currentPageNumber) {
            this.generateShared.closeOverviewDetail();
            // console.log('difficulty', this.generateShared.difficulty)
          }
        } else {
          if (clicked && this.pageNumber - 1 === this.currentPageNumber) {
            this.updateValues();
          }
          if (clicked && this.pageNumber === this.currentPageNumber) {
            this.generateShared.nextPage();
            // console.log('difficulty', this.generateShared.difficulty)
          }
        }
      }
    );
  }

  ngOnInit() {
    if (this.isDetail) {
      this.updateValues();
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  updateValues() {
    this.configButtons = new Array();
    const calories = this.generateShared.getCalories();
    for (let i = 0; i < calories.length; i++) {
      this.configButtons.push({
        isOneLine: false,
        title:
          this.difficultyService.convertDifficultyToPersian(
            calories[i].difficulty
          ) +
          ' (' +
          calories[i].amount +
          ' کالری)',
        description: calories[i].suitable
          ? this.difficultyService.convertDifficultyToKG(
              calories[i].difficulty
            ) + ' کیلو در ماه'
          : 'این رژیم مناسب شما نیست',
        id: i,
        type: 'difficulty',
        isDisabled: !calories[i].suitable,
        isSelected:
          this.isDetail && this.generateShared.difficulty === i ? true : false,
      });
    }
    this.dataIsReady = true;
  }
}
